import { ShoppingBag, Smartphone, CreditCard, Package, TrendingUp, Users } from "lucide-react";
import Card from '@/components/common/ui/Card';

const plans = [
    {
        title: "E-Commerce Platform Development",
        description:
            "Choose from a variety of platforms like Shopify, WooCommerce, or Magento. We'll help you build a robust online store that aligns with your business model.",
        icon: ShoppingBag,
    },
    {
        title: "Mobile Optimization",
        description:
            "With the rise of mobile shopping, we ensure your e-commerce site is fully optimized for mobile devices, providing a seamless shopping experience for users on the go.",
        icon: Smartphone,
    },
    {
        title: "Payment Gateway Integration",
        description:
            "Simplify transactions with secure and reliable payment gateway integration, allowing customers to pay via multiple methods for added convenience.",
        icon: CreditCard,
    },
    {
        title: "Inventory Management Solutions",
        description:
            "Streamline your inventory processes with our advanced management solutions. Keep track of stock levels, manage suppliers, and forecast demand effortlessly.",
        icon: Package,
    },
    {
        title: "Digital Marketing Services",
        description:
            "Enhance your online visibility with our targeted digital marketing strategies, including SEO, social media marketing, and email campaigns designed to attract and retain customers.",
        icon: TrendingUp,
    },
    {
        title: "Customer Relationship Management (CRM)",
        description:
            "Implement CRM solutions to build lasting relationships with your customers. Track interactions, manage leads, and personalize communication for better engagement.",
        icon: Users,
    },
];

export default function OtherServices() {
    return (
        <section className="container pt-16 pb-24">
            <div className="text-center">
                <h3 className="text-2xl md:text-4xl font-bold text-white leading-tight mb-12">
                    Comprehensive E-Commerce Solution
                </h3>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
                {plans.map((plan, index) => (
                    <Card
                        key={index}
                        title={plan.title}
                        description={plan.description}
                        icon={plan.icon}
                    />
                ))}
            </div>
        </section>
    );
}